<div
  class="sticky top-0 z-10 flex min-h-[44px] flex-row flex-wrap items-center gap-2 bg-[#fafafa] pb-2"
>
  <h2 class="!m-0 !font-bold">Filters</h2>
  <div class="flex grow">
    <mat-icon
      class="icon-sm opacity-50"
      matTooltip="Filters let you choose exactly which data you want to include in your report. For example, you can narrow results by date range, category, or status."
    >
      info
    </mat-icon>
  </div>
  @if (store.results$ | async; as results) {
    @if (store.dynamicFilterCount$ | async) {
      <div class="text-xs opacity-50">
        {{ store.dynamicFilterCount$ | async }} temporary filters applied
      </div>
      <button
        mat-icon-button
        color="primary"
        class="icon-sm"
        matTooltip="Reset Additional Filters"
        (click)="store.resetActiveFilters()"
      >
        <mat-icon>restart_alt</mat-icon>
      </button>
    }
  }
</div>

@if (store.dataSource$ | async; as dataSource) {
  <div class="flex flex-row flex-wrap gap-2">
    @for (filter of customReport().staticFilters; track filter.uid) {
      @if ({ filter, dataSource } | map: getFilterSummary; as summary) {
        <pr-custom-report-filter
          [dataSource]="dataSource"
          [filter]="filter"
          [isTemporary]="false"
        >
          @if (hasEditPermissions() && !readonly()) {
            <button
              mat-icon-button
              matTooltip="Edit Filter"
              class="icon-sm opacity-50"
              (click)="editFilter(filter)"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="Delete Filter"
              color="warn"
              class="icon-sm opacity-50"
              (click)="deleteFilter(filter)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          }
        </pr-custom-report-filter>
      }
    }

    @if (hasEditPermissions() && !readonly()) {
      <div
        matRipple
        class="hover:border-primary-200 hover:text-primary-200 flex min-h-[56px] w-64 cursor-pointer flex-row items-center justify-center gap-1 rounded-lg border-2 border-dashed border-slate-200 font-bold opacity-50 hover:opacity-100"
        (click)="addFilter()"
      >
        <mat-icon>add</mat-icon>
        <div>Add Filter</div>
      </div>
    } @else if (hasNoFilters()) {
      <div class="text-xs opacity-50">No Filters</div>
    }

    @for (filter of store.dynamicFilters$ | async; track filter.uid) {
      <pr-custom-report-filter
        [dataSource]="dataSource"
        [filter]="filter"
        [isTemporary]="true"
      >
        @if (!readonly()) {
          <button
            mat-icon-button
            matTooltip="Save Filter"
            color="primary"
            class="icon-sm opacity-50"
            (click)="saveFilter(filter)"
          >
            <mat-icon>save</mat-icon>
          </button>
        }
        <button
          mat-icon-button
          matTooltip="Reset Filter"
          color="primary"
          class="icon-sm opacity-50"
          (click)="resetFilter(filter)"
        >
          <mat-icon>restart_alt</mat-icon>
        </button>
      </pr-custom-report-filter>
    }
  </div>
}
